import type { CreateNotificationBodyContent } from './createNotificationBodyContent';
import type { CreateNotificationBodyMetadata } from './createNotificationBodyMetadata';
import type { CreateNotificationBodyRecipient } from './createNotificationBodyRecipient';
import type { CreateNotificationBodySender } from './createNotificationBodySender';
import type { CreateNotificationBodyType } from './createNotificationBodyType';

export type CreateNotificationBody = {
  autoSend?: boolean;
  channel: string;
  content: CreateNotificationBodyContent;
  /** @nullable */
  metadata?: CreateNotificationBodyMetadata;
  /** @nullable */
  notificationId?: string | null;
  priority?: string;
  recipient: CreateNotificationBodyRecipient;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  sender?: CreateNotificationBodySender;
  subject: string;
  type: CreateNotificationBodyType;
};
